module.exports = __webpack_public_path__ + "img/Glosario.7f4f6250.svg";